import { css, styled } from 'styled-components';

export const Container = styled.div<{
  $hasBottomBorder?: boolean;
  $hasDividers?: boolean;
  $hasTopBorder?: boolean;
}>`
  ${({
    $hasBottomBorder = false,
    $hasDividers = false,
    $hasTopBorder = false,

    theme,
  }) => css`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    overflow-x: auto;
    margin-top: 24px;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }

    gap: 8px;
    border: 1px solid ${theme.colorsV2.gray30};
    border-width: 0px;
    border-top-width: ${$hasTopBorder ? '1px' : '0px'};
    border-bottom-width: ${$hasBottomBorder ? '1px' : '0px'};
    padding-top: ${$hasTopBorder ? '12px' : '0px'};
    padding-bottom: ${$hasBottomBorder ? '12px' : '0px'};

    ${$hasDividers &&
    css`
      gap: 8px;

      ${theme.mediaQueries.lg} {
        gap: 16px;
      }
    `}
  `}
`;

export const Tab = styled.button<{ $isActive?: boolean }>`
  ${({ $isActive = false, theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row nowrap;
    gap: 8px;
    padding: 0px 8px;
    color: ${theme.colorsV2.gray60};
    background: transparent;
    border-radius: 100px;
    height: 40px;
    font-weight: 500;
    border-radius: 100px;
    letter-spacing: -0.16px;
    transition: background-color 0.2s ease-out;
    transition-property: background-color, color;
    font-size: 14px;

    ${theme.mediaQueries.lg} {
      padding: 0px 12px;
      font-size: 16px;
    }

    ${$isActive &&
    css`
      color: ${theme.colorsV2.black};
    `}

    &:hover:not(:disabled) {
      color: ${theme.colorsV2.black};

      & svg path {
        fill: ${theme.colorsV2.black};
      }
    }

    &:disabled {
      color: ${theme.colorsV2.gray40};
      cursor: not-allowed;

      & svg path {
        fill: ${theme.colorsV2.gray40};
      }
    }

    & span {
      font-weight: 400;
    }

    & svg path {
      fill: ${theme.colorsV2.gray60};
    }
  `}
`;

export const HintDot = styled.div`
  ${({ theme }) => css`
    width: 8px;
    height: 8px;
    background-color: ${theme.colorsV2.brandWatermelon};
    border-radius: 50%;
  `}
`;

export const CustomAccessoryContainer = styled.div`
  ${({ theme }) => css`
    ${theme.mediaQueries.sm} {
      margin-left: auto;
    }
  `}
`;
